// Tailwind v2–compatible class bundles (use bg-opacity + arbitrary [] values, not v3 slash opacity).

export const dropZoneBaseClass =
	'group mt-2 min-h-[8.75rem] w-full flex flex-col items-center justify-center ' +
	'border-2 border-dashed rounded-lg p-6 text-center cursor-pointer ' +
	'transition-colors duration-150 ' +
	'bg-gray-50 border-gray-300 ' +
	'dark:bg-dark-bg dark:border-gray-500 ' +
	'hover:border-blue-500 hover:bg-blue-50 ' +
	'dark:hover:border-blue-400 dark:hover:bg-blue-900 dark:hover:bg-opacity-20';

export const dropZoneActiveClass =
	'border-blue-500 bg-blue-50 ring-2 ring-blue-500 ring-opacity-25 ' +
	'dark:border-blue-400 dark:bg-blue-900 dark:bg-opacity-30 dark:ring-blue-400 dark:ring-opacity-30';

export const dropZoneTitleClass =
	'pointer-events-none text-sm font-medium text-gray-900 dark:text-dark-text ' +
	'group-hover:text-blue-700 dark:group-hover:text-blue-300';

export const dropZoneHintClass =
	'pointer-events-none text-xs text-gray-500 dark:text-gray-400 mt-2 ' +
	'group-hover:text-blue-600 dark:group-hover:text-blue-400';

export const removeImageButtonClass =
	'absolute top-2 right-2 z-10 flex h-8 w-8 items-center justify-center ' +
	'rounded-full bg-black bg-opacity-70 text-white text-lg leading-none ' +
	'hover:bg-opacity-90 transition-colors';

export const previewImageClass =
	'w-full max-h-[22.5rem] object-contain rounded-lg border border-gray-200 ' +
	'dark:border-dark-border bg-gray-50 dark:bg-dark-bg';

export const reportPanelClass =
	'lg:col-span-2 p-4 md:p-6 border border-gray-200 dark:border-dark-border ' +
	'rounded-lg bg-white dark:bg-dark-card min-h-[32rem]';

export const reportPanelInnerClass = 'h-full min-h-[28rem] flex flex-col';
